import { dynamicLoader } from '~/utils';

export const TestPage = dynamicLoader({
  name: 'TestPage',
  importFunc: () => import('./test-page'),
});